export const ComponentLang = {
  titles: {
    components: 'Componentes'
  }
};
